import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BE_API_AUTH_URL} from '../constants/app.constants';
import {AuthService} from './auth.service';

@Injectable({providedIn: 'root'})
export class PlatformNotificationService {
  constructor(private http: HttpClient, private auth: AuthService) {
  }

  recipients(search = '') {
    return this.http.get<any>(`${BE_API_AUTH_URL}/admin/notification-recipients`, {
      headers: this.auth.createAuthorizationHeader(),
      params: {search}
    });
  }

  sends(cursor?: string | null, limit = 20) {
    const params: Record<string, string> = {limit: String(limit)};
    if (cursor) params['cursor'] = cursor;
    return this.http.get<any>(`${BE_API_AUTH_URL}/admin/notifications/sends`, {
      headers: this.auth.createAuthorizationHeader(),
      params
    });
  }

  send(payload: unknown) {
    return this.http.post<any>(`${BE_API_AUTH_URL}/admin/notifications/send`, payload, {headers: this.auth.createAuthorizationHeader()});
  }

  detail(id: string) {
    return this.http.get<any>(`${BE_API_AUTH_URL}/admin/notifications/sends/${id}`, {headers: this.auth.createAuthorizationHeader()});
  }
}
